<template>
  <div class="min-h-screen ml-0 w-full lg:mr-3">
    <transition name="fade">
      <div
        v-show="loading"
        class="inset-0 absolute bg-black rounded-md bg-opacity-10 w-full"
      >
        <Loader class="center-h-v" />
      </div>
    </transition>

    <employee :user="user" :setLoading="setLoading"></employee>
  </div>
</template>

<script>
import Employee from "@/components/employees/employee.vue";
import Loader from "@/components/loader/loader.vue";

export default {
  name: "Profile",
  props: ["user"],
  components: {
    Employee,
    Loader,
  },
  created() {},
  data() {
    return {
      loading: false,
    };
  },
  methods: {
    setLoading(isLoading) {
      this.loading = isLoading ? true : false;
    },
  },
};
</script>
